module.exports = __webpack_public_path__ + "img/Salad Icon - charcoal.91a63dba.svg";